const data = {
    DownloadUrlBase:"https://jianyouexp.risfond.com/"
}

export default data;


// WEBPACK FOOTER //
// ./src/config/index.js